<mat-select
    [class]="'w-full select ' + selectStyle"
    [formControl]="companyFilter"
    [multiple]="multiple"
    [panelClass]="panelClass"
    (selectionChange)="updateCompanyFilter()"
    [placeholder]="placeholder"
    (openedChange)="onCompanyFilterDropdownClosed($event)"
>
    <mat-select-trigger>
        <span *ngIf="firstSelectionLabel as label">{{ label }}</span>
        <span *ngIf="additionalSelectionLabel as label">{{ label }}</span>
    </mat-select-trigger>
    <mat-option (click)="resetCompanyFilter()" class="clear-selection font-bold mat-select-with-remove-all">
        <span class="flex items-center text-lg pl-0.5">x</span>
        <span i18n class="pt-1">Clear selection</span>
    </mat-option>
    <mat-option *ngIf="allowAllActiveCustomersFilter" [value]="allActiveCustomersValue" class="font-bold" i18n>
        All active customers
    </mat-option>
    <mat-option [value]="noCompanyFilterValue" *ngIf="allowNoCompanyFilter" i18n>No affiliation</mat-option>
    <ng-container *ngFor="let company of companies$ | ngrxPush; let i = index; let companies = count">
        <mat-option
            *ngIf="i === getFirstDeactivatedIndex(companies$ | ngrxPush)"
            disabled
            class="!h-0 !min-h-0 !p-0 border-t border-iota-outline !cursor-default"
        >
        </mat-option>
        <mat-option [value]="company" [ngClass]="{ 'text-gray-400': isCompanyDeactivated(company) }">
            <span [ngClass]="{ 'font-normal': !isCompanyDeactivated(company) }">{{ getCompanyName(company) }}</span>
            <span *ngIf="isCompanyDeactivated(company)" class="font-bold" i18n> (deactivated)</span>
        </mat-option>
    </ng-container>
</mat-select>
